/*
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2025-09-02 11:12:45
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2025-09-08 15:30:29
 * @FilePath: /epec-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/rawMaterialOrder/common/rawMaterialDetail.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
//石化采购意向单\石化商城订单--原材料详情
export const detailContent = {
  //石化采购意向单
  purchaseFormData: [
    { label: '石化采购意向单编号：', value: 'stockAffirmId', },
    { label: '石化采购意向单名称：', value: 'stockAffirmName', },
    { label: '采购方式：', value: 'stockType', },
    { label: '类型：', value: 'dataType', },
    { label: '买方：', value: 'purchaserName', },
    { label: '编制时间：', value: 'createDate', },
    { label: 'ERP单号：', value: 'erpNo', },
  ],
  //石化商城订单
  mallOrderFormData: [
    { label: '石化商城订单编号：', value: 'orderNo', },
    { label: '采购商：', value: 'purchaseCompany', },
    { label: '结算方式：', value: 'isDoC', },
    { label: '订单类型：', value: 'purchaseRequestType', },
    { label: '下单时间：', value: 'submitTime', },
    { label: '要求到货时间：', value: 'arriveTime', },
    { label: 'ERP单号：', value: 'erpNo', },
  ],
  //原材料采购订单列表
  yclTableLabel: [
    { label: '原材料订单编号', param: 'orderNo', align: 'center', slot: 'toStockOrderOne' },
    { label: '订单状态', param: 'orderStatus', align: 'center', },
    { label: '供应商名称', param: 'supplierCompany', align: 'center', },
    // {label: '附件', param: '', align: 'center', slot: 'attachmentUpload', width: '120'},
    { label: 'AI审查建议结果', param: 'aiCheckResult', align: 'center', width: '120', slot: 'aiCheckResult', headerSlot: 'aiCheckResultHeader' },
    {
      label: '订单金额（元）', param: 'needPay', align: 'center', render: (row) => {
        return Number(row.needPay).toFixed(2);
      },
    },
    { label: '下单时间', param: 'createTime', align: 'center', },
  ],
  //库存订单列表
  kcTableLabel: [
    { label: '库存单编号', param: 'seqNo', align: 'center', slot: 'toStockOrderTwo' },
    { label: '供应商名称', param: 'supplierCompanyName', align: 'center', },
    { label: 'AI审查建议结果', param: 'aiCheckResult', align: 'center', width: '120', slot: 'aiCheckResult', headerSlot: 'aiCheckResultHeader' },
    { label: '采购日期', param: 'purchaseDate', align: 'center', },
    {
      label: '库存订单金额（元）', param: 'price', align: 'center', render: (row) => {
        return Number(row.price).toFixed(2);
      },
    },
    { label: '备注', param: 'remark', align: 'center', },
  ],

  //结算方式
  isDoC: {
    1: '货到付款',
    0: '款到发货',
  },
  //订单类型
  purchaseRequestType: {
    1: '标准',
    2: '寄售',
  },
  //采购方式
  stockType: {
    1: '询比价',
    2: '公开招标',
    3: '邀请招标',
    4: '框架协议执行',
  },
  //类型
  dataType: {
    1: '订货函',
    2: '中选通知',
    3: '中标通知',
  }
}